export default {
  "root": "_root_m2307_1",
  "rs-reshaped-loader": "_rs-reshaped-loader_m2307_1",
  "inner": "_inner_m2307_1",
  "--color-inherit": "_--color-inherit_m2307_1",
  "--color-primary": "_--color-primary_m2307_1",
  "--color-positive": "_--color-positive_m2307_1",
  "--color-critical": "_--color-critical_m2307_1",
  "--size-small": "_--size-small_m2307_1",
  "--size-medium": "_--size-medium_m2307_1",
  "--size-large": "_--size-large_m2307_1",
  "--size-small--m": "_--size-small--m_m2307_1",
  "--size-medium--m": "_--size-medium--m_m2307_1",
  "--size-large--m": "_--size-large--m_m2307_1",
  "--size-small--l": "_--size-small--l_m2307_1",
  "--size-medium--l": "_--size-medium--l_m2307_1",
  "--size-large--l": "_--size-large--l_m2307_1",
  "--size-small--xl": "_--size-small--xl_m2307_1",
  "--size-medium--xl": "_--size-medium--xl_m2307_1",
  "--size-large--xl": "_--size-large--xl_m2307_1"
};import "ni:sha-256;qmINSJG1ma0jyKsc6UIxuugwTlBvFagxpgih84zaXug";